import { render, staticRenderFns } from "./FullStats.vue?vue&type=template&id=11d61336"
import script from "./FullStats.vue?vue&type=script&lang=js"
export * from "./FullStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports